<template>
    <div class="toast__new_order">
        <div class="toast__new_order_wrap">
            <div ref="svgContainer" class="toast__new_order_logo">
            </div>
            <span class="toast__new_order_title">{{ title }}</span>
            <div class="toast__new_order_block">
                <div class="toast__new_order_block_row">
                    <span class="toast__new_order_block_row_text">{{ newOrderHasArrived }}</span>&nbsp
                    <span class="toast__new_order_block_row_main">{{ numberOrder }}</span>&nbsp
                    <span class="toast__new_order_block_row_text">{{ inTheAmount }}</span>&nbsp
                    <span class="toast__new_order_block_row_main">{{ sumOrder }}</span>
                </div>
                <div class="toast__new_order_block_row">
                    <span class="toast__new_order_block_row_text">{{ textOrder }}</span>&nbsp
                </div>
            </div>
        </div>
        <div class="toast__new_order_buttons">
            <button class="toast__new_order_buttons_button" @click.prevent="clickSkip">
                <span class="toast__new_order_buttons_button_text">{{ skipLabel }}</span>
            </button>
            <div class="toast__new_order_buttons_button cursor_pointer see" @click.prevent="clickSee">
                <span class="toast__new_order_buttons_button_text">{{ seeLabel }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {createHelpers} from "vuex-map-fields";
import formatNumber from "../../mixins/formatNumber";
import insertSvg from "../../mixins/insertSvg";
import __t from "../../mixins/translate";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})

export default {
    name: "toast_new_order",
    props: {
        newOrderIn: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
        ordersNewList: {
            type: Array,
            required: true,
        },
        toastId: {
            type: [String, Number],
            required: true,
        },
        closeToast: {
            type: Function,
            required: true,
        },
    },
    mixins: [formatNumber, insertSvg, __t],
    data() {
        return {
        }
    },
    mounted() {
        const itemNewOrderMenu = this.ordersNewList.find(item => item.order.id === this.newOrderIn.id);
        if (itemNewOrderMenu && itemNewOrderMenu.aggregator && itemNewOrderMenu.aggregator.icon) {
            this.insertSvg(itemNewOrderMenu.aggregator.icon);
        }
    },
    methods: {
        clickSee() {
            this.closeToast(this.toastId);
            EventBus.$emit('view_new_order', this.newOrderIn);
        },
        clickSkip() {
            this.closeToast(this.toastId);
        },
    },
    computed: {
        currencyUser() {
            if (this.user && this.user.currency_suffix) {
                return this.user.currency_suffix;
            }
            return '';
        },
        numberOrder() {
            if (this.newOrderIn && this.newOrderIn.order && this.newOrderIn.order.order_code) {
                return this.newOrderIn.order.order_code
            }
            return '';
        },
        sumOrder() {
            if (this.newOrderIn && this.newOrderIn.cost && this.newOrderIn.cost.total && this.user.locale) {
                return this.toCurrency(this.newOrderIn.cost.total, this.currencyUser, 'uk-UA', 2);
            }
            return '';
        },
        textOrder() {
            let textOrderNew = '';
            if (this.newOrderIn.is_market) {
                textOrderNew = `${this.__t('O.DELIVERY')}` + ', ';
            } else {
                textOrderNew = `${this.__t('O.PICKUP_FROM_THE_RESTAURANT')}` + ', ';
            }
            if (this.newOrderIn.is_pay_cache) {
                textOrderNew += `${this.__t('O.CASH')}` + '.'
            } else {
                textOrderNew += `${this.__t('O.CARD')}` + '.'
            }
            return textOrderNew;
        },
        title() {
            return `${this.__t('O.NEW_ORDER')}`;
        },
        newOrderHasArrived() {
            return `${this.__t('O.NEW_ORDER_HAS_ARRIVED')}`;
        },
        inTheAmount() {
            return `${this.__t('O.IN_THE_AMOUNT')}`;
        },
        skipLabel() {
            return `${this.__t('O.SKIP')}`;
        },
        seeLabel() {
            return `${this.__t('O.SEE')}`;
        },
    },
}
</script>
